module.exports = __webpack_public_path__ + "959fa4861720d2dcc3850d6e93b4a997.pdf";